export default __webpack_public_path__ + "static/media/bulkUpload.b8470b12.svg";